export default "__VITE_ASSET__d73041c3__"